<div
    class="bazis-infinite-scroll-content"
    scroll
    (scrollToBottom)="needNextPage$.next(true)"
    *transloco="let t"
>
    @let list = list$ | async;
    @let listExludeSelected = listExludeSelected$ | async;

    @if (list && isMultiple && selectedMap.size > 0) {
        <div class="bazis-item bazis-item_group">
            <div class="bh-flex bh-justify-content-between">
                <span (click)="toggleSelectedGroup()">
                    {{ t('title.selected') }} ( {{ selectedMap.size }} )
                    <bazis-icon
                        size="regular"
                        [name]="showSelectedGroup ? 'angle-small-up' : 'angle-small-down'"
                    ></bazis-icon>
                </span>
                <bazis-link
                    borderStyle="none"
                    fontWeight="500"
                    class="bh-hide-xl-up bazis-text_minor"
                    color="danger"
                    (click)="clearAll()"
                >
                    {{ t('filter.clear') }}
                </bazis-link>
            </div>
        </div>
        @if (showSelectedGroup) {
            @for (item of selectedList$ | async; track item.id; let i = $index) {
                <ng-template
                    [ngTemplateOutlet]="itemTpl"
                    [ngTemplateOutletContext]="{ item: item }"
                ></ng-template>
            }
        }
    }

    @if (list && isMultiple) {
        <div class="bazis-item bazis-item_group">
            <span>
                {{ t('title.search') }}
            </span>
        </div>
    }

    @if (showSearchGroup) {
        @for (item of listExludeSelected; track item; let i = $index) {
            <ng-template
                [ngTemplateOutlet]="itemTpl"
                [ngTemplateOutletContext]="{ item: item }"
            ></ng-template>
        }

        @if (!isMultiple && !listExludeSelected?.length) {
            @for (item of list; track item.id; let i = $index) {
                <ng-template
                    [ngTemplateOutlet]="itemTpl"
                    [ngTemplateOutletContext]="{ item: item }"
                ></ng-template>
            }
        }
    }

    @if (list?.length === 0 || listExludeSelected?.length === 0) {
        <div class="bazis-item bh-events-none">
            {{ t(emptyListKey || 'title.emptyList') }}
        </div>
    }

    @if (list && hasApplyBtn) {
        <bazis-button
            color="action"
            class="bh-block"
            [disabled]="selectedMap.size === 0"
            (click)="applyAll()"
        >
            {{ t('action.showCount', { count: selectedMap.size }) }}
        </bazis-button>
    }
</div>
